import type { Block, Section } from "../contract"
import type { TurnView } from "../store"
import { viewFromOutcome } from "../answer/thread"

/** The masked copy a share link serves (backend nira/agent/share.py). */
export interface Shared {
  question: string
  context: { side: "taxpayer" | "revenue"; state: string }
  view: TurnView
  author: { name: string; firm: string } | null
  clientView: boolean
  sharedAt: string
}

type Obj = Record<string, unknown>
const obj = (v: unknown): Obj | null => (v && typeof v === "object" && !Array.isArray(v) ? (v as Obj) : null)
const str = (v: unknown) => (typeof v === "string" ? v : "")

/** Parse defensively: anything unreadable yields null and the page says the link is broken. */
export function parseShared(key: string, data: unknown): Shared | null {
  const d = obj(data)
  const outcome = obj(d?.outcome)
  if (!d || !outcome || !obj(outcome.head)) return null
  const ctx = obj(d.context) ?? {}
  const author = obj(d.author)
  const question = str(d.question)
  return {
    question,
    context: { side: ctx.side === "revenue" ? "revenue" : "taxpayer", state: str(ctx.state) },
    view: viewFromOutcome(key, question, outcome),
    author: author && str(author.name) ? { name: str(author.name), firm: str(author.firm) } : null,
    clientView: d.client_view === true,
    sharedAt: str(d.shared_at),
  }
}

/** The blocks of the section planned with `tag`, or none. */
export function blocksFor(view: TurnView, tag: string): Block[] {
  const item = (view.plan ?? []).find((p) => p.tag.toUpperCase() === tag)
  const section: Section | undefined = item ? view.sections[item.id] : undefined
  return section?.blocks ?? []
}

/** "17 Oct 2026" from an ISO timestamp. */
export function sharedDay(iso: string): string {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
}
